import React from "react";
import { Footer, Home, Navbar } from "./components";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { blue, grey, blueGrey } from "@mui/material/colors";

import "./App.css";
import { useGlobalStates } from "./context/GlobalStates";

const App = () => {
	const { isDarkMode } = useGlobalStates();

	const showAlert = () => {
		let alert = document.createElement("div");
		alert.textContent = "You cannot inspect on this site!";
		alert.style.position = "fixed";
		alert.style.top = "50%";
		alert.style.left = "50%";
		alert.style.transform = "translate(-50%, -50%";
		alert.style.backgroundColor = "#ef233c";
		alert.style.color = "#ffffff";
		alert.style.padding = "20px";
		alert.style.zIndex = "999";
		alert.style.borderRadius = "10px";

		document.body.appendChild(alert);

		setTimeout(() => {
			alert.remove();
		}, 3000);
	};

	window.addEventListener("contextmenu", function (e) {
		showAlert();
		e.preventDefault();
	});

	document.addEventListener("keydown", (event) => {
		if (event.ctrlKey && event.shiftKey && event.keyCode === 73) {
			showAlert();
			event.preventDefault();
		}
	});

	const darkTheme = createTheme({
		palette: {
			mode: isDarkMode ? "dark" : "light",
			primary: {
				...(isDarkMode ? { main: blue[300] } : blue),
			},
			background: {
				...(isDarkMode
					? {
							default: blueGrey[900],
							paper: blueGrey[900],
					  }
					: {
							default: grey[50],
							paper: grey[50],
					  }),
			},
			text: {
				...(isDarkMode
					? {
							primary: "#fff",
							secondary: grey[500],
					  }
					: {
							primary: grey[900],
							secondary: grey[800],
					  }),
			},
		},
	});

	return (
		<ThemeProvider theme={darkTheme}>
			<CssBaseline />
			<div className="w-full flex flex-col justify-center items-center">
				<Navbar />
				<div className="main-container">
					<Home />
				</div>
				<div className=" w-full sm:absolute -bottom-5 mt-5 sm:mt-0">
					<Footer />
				</div>
			</div>
		</ThemeProvider>
	);
};

export default App;
